import useLazyImgSrc from 'hooks/useLazyImgSrc'
import * as React from 'react'
import styled from 'styled-components'
import { ProductImageProps } from './types'

export default function ProductImage(props: ProductImageProps) {
  const [ref, imgUrl] = useLazyImgSrc<HTMLImageElement>(props.img, 100)
  return (
    <Wrapper className={props.className}>
      <img ref={ref} src={imgUrl} alt={props.alt} />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  > img {
    max-width: 100%; /* Prevent images from exceeding their container */
    max-height: 100%; /* Prevent overflow */
    width: 100%; /* Ensure the image scales with the grid area */
    height: 100%; /* Ensure the image fills the grid area */
    object-fit: cover; /* Scale image to cover grid area */
  }
`
